import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-160f7112"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex mb" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "flex" }

import { IonButton, IonIcon, IonInput } from '@ionic/vue'
import { maskitoNumberOptionsGenerator } from '@maskito/kit'
import { addCircle, playBack, playForward, removeCircle } from 'ionicons/icons'


export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonsRow',
  props: {
    value: {},
    min: {},
    max: {}
  },
  emits: ['decrease', 'val-change', 'increase'],
  setup(__props: any) {

const { min, max } = __props


const options = maskitoNumberOptionsGenerator({ min, max })

return (_ctx: any,_cache: any) => {
  const _directive_maskito = _resolveDirective("maskito")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(IonButton), {
        size: "small",
        fill: "clear",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('decrease', 10))),
        disabled: _ctx.value <= _ctx.min
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonIcon), {
            slot: "icon-only",
            icon: _unref(playBack)
          }, null, 8, ["icon"])
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_unref(IonButton), {
        fill: "clear",
        slot: "end",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('decrease'))),
        disabled: _ctx.value <= _ctx.min
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonIcon), {
            slot: "icon-only",
            icon: _unref(removeCircle)
          }, null, 8, ["icon"])
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createElementVNode("div", null, [
      _withDirectives(_createVNode(_unref(IonInput), {
        slot: "end",
        label: "Number input",
        type: "number",
        min: _ctx.min,
        max: _ctx.max,
        value: _ctx.value,
        onIonChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('val-change', +$event.target.value))),
        class: "ion-text-center"
      }, null, 8, ["min", "max", "value"]), [
        [_directive_maskito, _unref(options)]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(IonButton), {
        fill: "clear",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('increase'))),
        disabled: _ctx.value >= _ctx.max
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonIcon), {
            slot: "icon-only",
            icon: _unref(addCircle)
          }, null, 8, ["icon"])
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_unref(IonButton), {
        size: "small",
        fill: "clear",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('increase', 10))),
        disabled: _ctx.value >= _ctx.max
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonIcon), {
            slot: "icon-only",
            icon: _unref(playForward)
          }, null, 8, ["icon"])
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ]))
}
}

})